module.exports = __webpack_public_path__ + "static/media/edit.9708173e.svg";